import { getAction, postAction, putAction, deleteAction } from '@/api/manage'

const PLUGIN_API_PREFIX = '/api/plugin/cert-crop'

// 授权key管理（仅超管）
export const getKeyList = (params) => getAction(`${PLUGIN_API_PREFIX}/keys/list`, params)
export const addKey = (data) => postAction(`${PLUGIN_API_PREFIX}/keys/add`, data)
export const updateKeyStatus = (data) => putAction(`${PLUGIN_API_PREFIX}/keys/status`, data)
export const deleteKey = (id) => deleteAction(`${PLUGIN_API_PREFIX}/keys/delete/${id}`)

// 训练管理（仅超管）
export const startTraining = () => postAction(`${PLUGIN_API_PREFIX}/training/start`)
export const stopTraining = () => postAction(`${PLUGIN_API_PREFIX}/training/stop`)
export const getTrainingStatus = () => getAction(`${PLUGIN_API_PREFIX}/training/status`)
